import ActividadTile from './ActividadTile';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCalendarAlt } from 'react-icons/fa';
import { RoleLayout, RoleGrid, RoleTile } from './RoleShell';

export default function Imagen() {
  const navigate = useNavigate();

  return (
    <RoleLayout
      title="Panel — Imagen / Anfitrión"
      subtitle="Administra tus reservas asignadas y mantén el control de tus invitados."
      roleLabel="Rol: Imagen / Anfitrión"
    >
      <RoleGrid>
        <ActividadTile/>
        <RoleTile icon={FaCalendarAlt} label="Invitaciones" description="Genera y recupera tus invitaciones según el cupo de cada evento." onClick={()=>navigate('/dashboard/invitaciones')}/>
        <RoleTile
          icon={FaCalendarAlt}
          label="Reservas"
          description="Revisa y gestiona las reservas que tienes a cargo."
          onClick={() => navigate('/dashboard/reservas')}
        />
      </RoleGrid>
    </RoleLayout>
  );
}
